"use client";

import { c as _c } from "react/compiler-runtime";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Image from "next/image";
export default function HeroSwiper() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [Pagination, Autoplay];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      delay: 9000,
      disableOnInteraction: false
    };
    t2 = {
      el: ".hero-pagination",
      clickable: true
    };
    t3 = {
      0: {
        slidesPerView: 1
      },
      768: {
        slidesPerView: 1
      },
      1024: {
        slidesPerView: 1
      }
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section aria-label="Featured content" className="bg-primary overflow-hidden"><Swiper modules={t0} loop={true} autoplay={t1} pagination={t2} breakpoints={t3} className="hero-swiper">{[1, 2, 3].map(_temp)}</Swiper><div className="hero-pagination flex justify-center gap-3 py-4 bg-white border-t" /></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp(item) {
  return <SwiperSlide key={item}><div className="w-full h-40 sm:h-75 md:h-85 lg:h-94 relative"><Image src={`/assets/slider/slider${item}.jpg`} alt={`slider-${item}`} fill={true} className="w-full h-auto sm:h-75 md:h-85 lg:h-94 object-cover" /></div></SwiperSlide>;
}